<script>
import { cmsMenuLayerProps, useCmsMenuLayer } from "./mixin";
import List from "@/components/molecules/list";
import ListItemNavigation from "@/components/molecules/list-item-navigation";

export default {
  name: "CmsMenuLayerMobile",
  components: {
    List,
    ListItemNavigation
  },
  props: {
    ...cmsMenuLayerProps()
  },
  emits: ["show"],
  setup() {
    const { currentChild, showChild, hideChild } = useCmsMenuLayer();
    return {
      currentChild,
      showChild,
      hideChild
    };
  }
};
</script>

<template>
  <List v-if="category.attributes && category.attributes.children && category.attributes.children.data && category.attributes.children.data.length > 0">
    <template
      v-for="(child, index) in category.attributes.children.data"
      :key="`cms-menu-layer-${index}`"
    >
      <template v-if="child.attributes.children.data.length > 0">
        <ListItemNavigation
          no-border
          class="c-cms-menu__item"
          @click="$emit('show', child)"
        >
          {{ child.attributes.libelle }}
        </ListItemNavigation>
      </template>
      <template v-else>
        <ListItemNavigation
          no-border
          :to="child.attributes.slug"
          class="c-cms-menu__item"
        >
          {{ child.attributes.libelle }}
        </ListItemNavigation>
      </template>
    </template>
  </List>
</template>

<style lang="scss" scoped>
.c-cms-menu__item {
  border-bottom: 1px solid color(grey-5);
}
</style>
